import React, { useEffect, useState } from "react";
import { inventory } from "../../api";
import { Table } from "react-bootstrap";
import NormalInput from "../form/HorizontalNormalInput";

export const FulfillPurchaseOrder = ({ item, onChange }) => {
  const [inventories, setInventories] = useState([]);
  const [payload, setPayload] = useState({});
  const [leftItem, setLeftItem] = useState(Number(item.quantity));
  const [isOut, setIsOut] = useState(false);
  const getInventory = async () => {
    const res = await inventory.list({
      key: item.name,
    });

    if (res.ok) {
      const body = await res.json();
      setInventories(body.data);
    }
  };

  const handleChangeReceived = (id, qty) => {
    const p = { ...payload };
    p[id] = Number(qty);
    setPayload(p);

    const totalReceived = Object.entries(p).reduce((prev, [key, value]) => {
      return prev + value;
    }, 0);

    const left = item.quantity - totalReceived;
    setLeftItem(left);
    if (left < 0) {
      setIsOut(true);
    } else {
      setIsOut(false);
    }

    onChange({
      payload: p,
    });
  };

  useEffect(() => {
    getInventory();
  }, []);
  return (
    <div>
      <p style={{ marginBottom: 10 }}>
        {item.name} ({leftItem}/{item.quantity})
        {isOut && <span style={{ color: "red" }}> Item not available!</span>}
      </p>
      <Table striped bordered>
        <thead>
          <tr>
            <td>Part Name</td>
            <td>Location</td>
            <td>Received</td>
          </tr>
        </thead>
        <tbody>
          {inventories.map((inv, i) => (
            <tr key={i}>
              <td style={{ verticalAlign: "middle" }}>{inv.part?.part_name}</td>
              <td style={{ verticalAlign: "middle" }}>
                {inv.location?.location_name}
              </td>
              <td>
                <input
                  defaultValue={0}
                  onChange={(e) => handleChangeReceived(inv.id, e.target.value)}
                  className="form-control"
                  style={{ width: "100%" }}
                  type="number"
                  max={item.quantity}
                  min={0}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
